import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const ArticlePage = lazy(() => import('./article-page').then((m) => ({ default: m.ArticlePage })));
const KnowledgeCategoryPage = lazy(() => import('./category-page').then((m) => ({ default: m.KnowledgeCategoryPage })));
const ArticleEditorPage = lazy(() => import('./editor-page').then((m) => ({ default: m.ArticleEditorPage })));
const KnowledgeHubPage = lazy(() => import('./hub-page').then((m) => ({ default: m.KnowledgeHubPage })));

export const knowledgeRoutes: RouteObject[] = [
  {
    path: 'knowledge',
    handle: { crumb: 'Knowledge Hub' },
    children: [
      { index: true, element: <KnowledgeHubPage /> },
      { path: 'new', element: <ArticleEditorPage />, handle: { crumb: 'New article' } },
      { path: 'c/:category', element: <KnowledgeCategoryPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.category ?? 'Category' } },
      { path: ':id', element: <ArticlePage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Article' } },
      { path: ':id/edit', element: <ArticleEditorPage />, handle: { crumb: 'Edit' } },
    ],
  },
];
